import { CdkStepLabel } from '@angular/cdk/stepper';
import { Directive } from '@angular/core';

@Directive({
  selector: '[palantirStepLabel]',
  standalone: false,
})
export class PalantirStepLabel extends CdkStepLabel {}
